module.exports = __webpack_public_path__ + "static/media/9440.1a5c7ca6.jpg";